export default __webpack_public_path__ + "static/media/cloudy2.e857dd65.svg";